import React from "react";
import { SectionWrapper } from "../../../styles/common";
import LoadingSpinner from "../../shared/ui/LoadingSpinner";
import App from "@graphic/App";

const Malligyong3D = ({ enteringTime, selectedNoradId, title }) => {
  return (
    <SectionWrapper>
      <h2 className="title">Global View (3D)</h2>
      <div className="content">
        {/* <img src='/static/earth.gif' alt='earth-img' /> */}
        {enteringTime ? (
          <App
            map="/static/earth-large.jpg"
            bump="/static/bump-large.jpg"
            clouds="/static/clouds-large.jpg"
            time={enteringTime}
            noradId={selectedNoradId}
            satType={title}
          />
        ) : (
          <LoadingSpinner />
        )}
      </div>
    </SectionWrapper>
  );
};

export default Malligyong3D;
